/* eslint-disable */
import { findPostHelper, findCommentHelper } from "@/store/modules/helpers/helpers.js";

export function appendCommentToPost(state, { comment }) {
	let post = null
	if(comment.post) {
		post = findPostHelper(state, comment.post.id)
	}
	else if(comment.post_id) {
		post = findPostHelper(state, comment.post_id)
	}
	if(post) {
		if (!comment.parent_id) {
			comment.answers = []
			post.comments.unshift(comment)
			post.comments_root_count = post.comments_root_count + 1
		} else {
			let parentComment = findCommentHelper(state, post, comment.root_id)

			if (!parentComment.answers) {
				parentComment.answers = []
			}
			if (!parentComment.answers_count) {
				parentComment.answers_count = 0
			}
			(parentComment.answers).push(comment)
			parentComment.answers_count = parentComment.answers_count + 1
		}
	}
}

export function replaceCommentInPost(state, { comment }) {
	let post = findPostHelper(state, comment.post.id)
	if (!comment.parent_id) {
		let index = (post.comments).findIndex(c => c.id === comment.id)
		post.comments.splice(index, 1, Object.assign(post.comments[index], comment))
	} else {
		let parentComment = findCommentHelper(state, post, comment.root_id),
			index = (parentComment.answers).findIndex(c => c.id === comment.id)
		parentComment.answers.splice(index, 1, comment)
	}
}

export function removeCommentFromPost(state, { comment }) {
	let post = findPostHelper(state, comment.post.id)

	if (!comment.parent_id) {
		let comments = post.comments.findIndex(c => c.id === comment.id )
		post.comments.splice(comments, 1)
		post.comments_root_count--
	} else {
		let comments = post.comments.find(c => c.id === comment.root_id),
			answers = comments.answers.findIndex(a => a.id === comment.id )
		comments.answers.splice(answers, 1)
		comments.answers_count--
	}
}

export function appendCommentsToPost(state, { id, data, sort = null }) {
	let post = findPostHelper(state, id),
		comments = data.data

	post.comments_sort = sort
	post.comments_page = data.meta.current_page
	for (let i = 0; i < comments.length; i++) {
		let comment = comments[i]
		if (!(post.comments).find(c => c.id === comment.id)) {
			(post.comments).push(comment)
			// post.comments_root_count = post.comments_root_count + 1
		}
	}
}

export function appendAnswersToComment(state, { postID, commentID, data }) {
	let post = findPostHelper(state, postID),
		comment = findCommentHelper(state, post, commentID),
		answers = data.data

	comment.answers_page = data.meta.current_page

	for (let i = 0; i < answers.length; i++) {
		let answer = answers[i]
		if (!(comment.answers).find(a => a.id === answer.id))
			(comment.answers).push(answer)
	}
}
/* eslint-enable */
